import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withKeys as _withKeys, createBlock as _createBlock } from "vue";
import _imports_0 from '../../assets/img/eye-close.png';
import _imports_1 from '../../assets/img/eye-open.png';
const _hoisted_1 = {
  class: "btn-box"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_form_item = _resolveComponent("el-form-item");
  const _component_el_form = _resolveComponent("el-form");
  const _component_el_dialog = _resolveComponent("el-dialog");
  return _openBlock(), _createBlock(_component_el_dialog, {
    modelValue: $setup.dialogVisible,
    "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => $setup.dialogVisible = $event),
    title: _ctx.$t('message.changeYourPwd'),
    width: "640px",
    center: "",
    "custom-class": "form-dialog update-pwd-dialog",
    "before-close": $setup.close,
    "close-on-click-modal": false,
    top: "25vh"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_form, {
      ref: "ruleFormRef",
      model: $setup.ruleForm,
      rules: $setup.rules,
      "label-width": $setup.lang === 'en' ? '160px' : '110px',
      class: "form-box iconfont update-pwd-form",
      onKeyup: _cache[13] || (_cache[13] = _withKeys($event => $setup.submit(true), ["enter"]))
    }, {
      default: _withCtx(() => [_createVNode(_component_el_form_item, {
        label: _ctx.$t('message.currentPwd'),
        prop: "oldPassword"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: $setup.ruleForm.oldPassword,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $setup.ruleForm.oldPassword = $event),
          modelModifiers: {
            trim: true
          },
          type: $setup.passwordShow.oldPassword ? 'text' : 'password',
          maxlength: "75",
          onKeyup: _cache[1] || (_cache[1] = $event => $setup.ruleForm.oldPassword = $setup.ruleForm.oldPassword.replace(/[^\x00-\xff]/g, ''))
        }, null, 8, ["modelValue", "type"]), !$setup.passwordShow.oldPassword ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          src: _imports_0,
          alt: "",
          class: "eye",
          onClick: _cache[2] || (_cache[2] = $event => $setup.passwordShow.oldPassword = true)
        })) : (_openBlock(), _createElementBlock("img", {
          key: 1,
          src: _imports_1,
          alt: "",
          class: "eye",
          onClick: _cache[3] || (_cache[3] = $event => $setup.passwordShow.oldPassword = false)
        }))]),
        _: 1
      }, 8, ["label"]), _createVNode(_component_el_form_item, {
        label: _ctx.$t('message.newPwd'),
        prop: "newPassword"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: $setup.ruleForm.newPassword,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => $setup.ruleForm.newPassword = $event),
          modelModifiers: {
            trim: true
          },
          type: $setup.passwordShow.newPassword ? 'text' : 'password',
          maxlength: "16",
          onKeyup: _cache[5] || (_cache[5] = $event => $setup.ruleForm.newPassword = $setup.ruleForm.newPassword.replace(/[^\x00-\xff]/g, '').replace(/([\s\u3000]*|[\r\n\u3000]*)/gi, ''))
        }, null, 8, ["modelValue", "type"]), !$setup.passwordShow.newPassword ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          src: _imports_0,
          alt: "",
          class: "eye",
          onClick: _cache[6] || (_cache[6] = $event => $setup.passwordShow.newPassword = true)
        })) : (_openBlock(), _createElementBlock("img", {
          key: 1,
          src: _imports_1,
          alt: "",
          class: "eye",
          onClick: _cache[7] || (_cache[7] = $event => $setup.passwordShow.newPassword = false)
        }))]),
        _: 1
      }, 8, ["label"]), _createVNode(_component_el_form_item, {
        label: _ctx.$t('message.confirm'),
        prop: "againPassword"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: $setup.ruleForm.againPassword,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => $setup.ruleForm.againPassword = $event),
          modelModifiers: {
            trim: true
          },
          type: $setup.passwordShow.againPassword ? 'text' : 'password',
          maxlength: "16",
          onKeyup: _cache[9] || (_cache[9] = $event => $setup.ruleForm.againPassword = $setup.ruleForm.againPassword.replace(/[^\x00-\xff]/g, '').replace(/([\s\u3000]*|[\r\n\u3000]*)/gi, ''))
        }, null, 8, ["modelValue", "type"]), !$setup.passwordShow.againPassword ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          src: _imports_0,
          alt: "",
          class: "eye",
          onClick: _cache[10] || (_cache[10] = $event => $setup.passwordShow.againPassword = true)
        })) : (_openBlock(), _createElementBlock("img", {
          key: 1,
          src: _imports_1,
          alt: "",
          class: "eye",
          onClick: _cache[11] || (_cache[11] = $event => $setup.passwordShow.againPassword = false)
        }))]),
        _: 1
      }, 8, ["label"]), _createElementVNode("div", _hoisted_1, [_createElementVNode("div", {
        class: "btn",
        onClick: _cache[12] || (_cache[12] = (...args) => $setup.submit && $setup.submit(...args))
      }, _toDisplayString(_ctx.$t('submit.changePwd')), 1)])]),
      _: 1
    }, 8, ["model", "rules", "label-width"])]),
    _: 1
  }, 8, ["modelValue", "title", "before-close"]);
}